import { App, notification as staticNotification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';
import { isRTL } from './language';
import { ReactNode } from 'react';

type NotificationType = 'success' | 'error' | 'info' | 'warning';

// Context-aware instance provided by antd <App>, set via <NotificationHolder />
let notificationApi: NotificationInstance | null = null;

export const NotificationHolder = () => {
	notificationApi = App.useApp().notification;
	return null;
};

const openNotification = (type: NotificationType, message: string, description?: ReactNode) => {
	(notificationApi ?? staticNotification)[type]({
		message,
		description,
		className: type,
		placement: isRTL() ? 'topLeft' : 'topRight',
	});
};

// Notification service with methods for each notification type
const NotificationService = {
	success: (message: string, description?: ReactNode) => openNotification('success', message, description),
	error: (message: string, description?: ReactNode) => openNotification('error', message, description),
	info: (message: string, description?: ReactNode) => openNotification('info', message, description),
	warning: (message: string, description?: ReactNode) => openNotification('warning', message, description),
};

export default NotificationService;
